<template>
  <v-card
    elevation="0"
    outlined
  >
    <v-card-title>
      <v-icon class="mr-2">
        mdi-table
      </v-icon>
      Report Data
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="reportHeaders"
        :items="flattenedReportData"
        :items-per-page="10"
        multi-sort
      >
        <template #item.matchedLeadPercentage="{ item }">
          {{ item.matchedLeadPercentage }}%
        </template>
        <template #item.acceptedLeadPercentage="{ item }">
          {{ item.acceptedLeadPercentage }}%
        </template>
        <template #item.acceptanceRate="{ item }">
          {{ item.acceptanceRate }}%
        </template>
        <template #item.fundingRate="{ item }">
          {{ item.fundingRate }}
        </template>
        <template #item.fundedLeadPercentage="{ item }">
          {{ item.fundedLeadPercentage }}%
        </template>
        <template #item.totalFundedAmount="{ item }">
          ${{ item.totalFundedAmount.toLocaleString() }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatPercentage } from '@/filters';

export default {
  name: 'ReportTable',

  props: {
    reportData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      reportHeaders: [
        {
          text: 'Bucket Type',
          value: 'bucketType',
          sortable: true,
        },
        {
          text: 'Test Name',
          value: 'testName',
          sortable: true,
        },
        {
          text: 'Strategy Name',
          value: 'strategyName',
          sortable: true,
        },
        {
          text: 'Matched Leads',
          value: 'matchedLeadCount',
          sortable: true,
        },
        {
          text: 'Accepted Leads',
          value: 'acceptedLeadCount',
          sortable: true,
        },
        {
          text: 'Acceptance %',
          value: 'acceptanceRate',
          sortable: true,
        },
        {
          text: 'Funded Leads',
          value: 'fundedLeadCount',
          sortable: true,
        },
        {
          text: 'Funding %',
          value: 'fundingRate',
          sortable: true,
        },
        {
          text: 'Total Funded Amount',
          value: 'totalFundedAmount',
          sortable: true,
        },
      ],
    };
  },

  computed: {
    flattenedReportData() {
      const flattened = [];

      this.reportData.forEach((bucket) => {
        bucket.tests.forEach((test) => {
          test.strategies.forEach((strategy) => {
            flattened.push({
              bucketType: bucket.bucketType,
              testName: test.testName,
              strategyName: strategy.strategyName,
              ...strategy.summary,
            });
          });
        });
      });

      return flattened;
    },
  },

  methods: {
    formatPercentage,
  },
};
</script>
